import { Action } from 'cadenza/action';
import { download } from 'cadenza/utils/download';

export class ReportExportAction extends Action {

  readonly #mediaType;
  readonly #url;
  readonly #label;

  constructor (mediaType: string, url: string, label: string) {
    super({ label });
    this.#mediaType = mediaType;
    this.#url = url;
    this.#label = label;
  }

  override executeSync () {
    download(this.#url, {
      headers: {
        'Accept': this.#mediaType
      }
    });
  }

}
